/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import s from './index.module.scss';
import common from '../../index.module.scss';

function NutritionExperts () {
	const { T } = useT();
	useEffect(() => {
		steps.setStepStatus({
			stepName: 'nutrition_experts',
			stepStatus: true
		});
	}, []);

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>{T('nutrition_experts')}</h1>
			<div className={s.doctor_wrapper}>
				<div className={s.doctor_container}>
					<div className={s.doctor_image} />
					<div className={s.doctor_namecontainer}>
						<div className={s.doctor_name}>{T('nutrition_experts_expert_name')}</div>
						<div className={s.doctor_description}>{T('nutrition_experts_expert_post_0')}</div>
						<div className={s.doctor_description}>{T('nutrition_experts_expert_post_1')}</div>
					</div>
				</div>
				<p className={s.doctor_text}>{T('nutrition_experts_message')}</p>

				<ul className={s.doctor_icons}>
					<li className={s.doctor_icons_abm1} />
					<li className={s.doctor_icons_abm2} />
					<li className={s.doctor_icons_abm3} />
				</ul>
			</div>
		</div>
	);
}

export default NutritionExperts;
